export enum RutterValidationStatus {
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
}
